export const colors = {
  background: '#07070f',
  surface: 'rgba(255,255,255,0.03)',
  surfaceHover: 'rgba(255,255,255,0.05)',
  border: 'rgba(255,255,255,0.06)',
  borderStrong: 'rgba(255,255,255,0.12)',

  accent: '#6366f1',
  accentSecondary: '#8b5cf6',
  accentGradient: 'linear-gradient(135deg, #6366f1, #8b5cf6)',

  textPrimary: 'rgba(255,255,255,0.95)',
  textSecondary: 'rgba(255,255,255,0.75)',
  textTertiary: 'rgba(255,255,255,0.55)',
  textLabel: 'rgba(255,255,255,0.5)',

  tooltipBg: 'rgba(12,12,22,0.95)',

  domains: ['#6366f1', '#34d399', '#fb923c', '#f43f5e', '#22d3ee', '#a3e635'],
} as const;

export const domainColor = (index: number): string => {
  const palette = colors.domains;
  return palette[index % palette.length] ?? palette[0]!;
};

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '18px',
  xl: '24px',
  xxl: '32px',
} as const;

export const radii = {
  sm: '6px',
  md: '10px',
  lg: '14px',
  xl: '20px',
} as const;

export const fontWeights = {
  light: 300,
  body: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
} as const;
